import { cbSemanticCssVars, elevationCss } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { claimToken } from 'apis/restaurant-api/merchant-admin/user/api';
import { Typography as T } from 'common/typography';

const Root = styled.div`
  margin-block-start: 16px;
`;

const ContentBox = styled.div`
  ${elevationCss(2)}
  margin: 0 32px 16px;
  border-radius: 4px;
  overflow: hidden;
`;

const SpinnerContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Heading = styled(T.Heading2)`
  width: 100%;
  margin-block-end: 16px;
  text-align: center;
`;

const ErrorContainer = styled.div`
  color: ${cbSemanticCssVars.textSecondary};
  background-color: ${cbSemanticCssVars.surfaceMain};
  padding: 20px;
  text-align: center;
`;

const InviteToken = () => {
  const match = useRouteMatch<{ token: string }>();

  const { isSuccess, isError, isLoading } = useQuery(
    ['/merchant-admin/invites/', match.params.token],
    () => claimToken(match.params.token),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  );

  return (
    <Root>
      {isLoading && (
        <SpinnerContainer>
          <Spinner size="large" />
        </SpinnerContainer>
      )}
      {isSuccess && <Redirect to={{ pathname: '/' }} />}
      {isError && (
        <>
          <Heading>
            <FormattedMessage id="invites.header" />
          </Heading>
          <ContentBox>
            <ErrorContainer>
              <FormattedMessage id="invites.errorMessage" />
            </ErrorContainer>
          </ContentBox>
        </>
      )}
    </Root>
  );
};

export default InviteToken;
